var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{style:({width: _vm.width}),attrs:{"type":"month","placeholder":"请输入批次号","format":"yyyyMM","size":_vm.size},on:{"change":_vm.updateValue},model:{value:(_vm.bindValue),callback:function ($$v) {_vm.bindValue=$$v},expression:"bindValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }